import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';

import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { AgreementTypeSchema } from './agreement.schemas';
import { agreementApiPath } from './apiPath';

const PostTermsAgreementsRequestSchema = z
  .object({
    termsTypes: z.array(AgreementTypeSchema).min(1),
  })
  .describe('PostTermsAgreementsRequestSchema');

export type PostTermsAgreementsRequest = z.infer<typeof PostTermsAgreementsRequestSchema>;

const PostTermsAgreementsResponseDataSchema = z
  .object({
    termsTypes: z.array(AgreementTypeSchema),
  })
  .describe('PostTermsAgreementsResponseDataSchema');

const PostTermsAgreementsResponseSchema = createApiResponseSchema(
  PostTermsAgreementsResponseDataSchema,
);

export type PostTermsAgreementsResponse = z.infer<typeof PostTermsAgreementsResponseSchema>;

export const postTermsAgreements = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PostTermsAgreementsRequestSchema),
    (params: PostTermsAgreementsRequest) =>
      executeStandardRequest(() =>
        privateHttpClient.post<PostTermsAgreementsResponse>(
          agreementApiPath.postTermsAgreements,
          params,
        ),
      ),
    validateApiResponse(PostTermsAgreementsResponseSchema),
  ),
);
